export var Name = 'reset-shipping-selection';
export var ResetShippingSelectionEvent = Name;